import React from "react";
import { makeStyles } from "@material-ui/core/styles";

export const SingleVehicleCss = makeStyles((theme) => ({
    pageContentDIv: {
        //marginTop:30,
        padding: 15
    },
    doneIcon: {
        color: '#00875a',
        fontSize: 16,
        marginTop: -2,
        marginLeft: 8
    },
    indicator:{
      color:"#c4c4c4",
      fontSize:10,
      margin:"0px 8px"
    },
    STARTED: {
        color: "#2680eb",
        fontSize: 12,
    },
    COMPLETED: {
        color: "#00875a",
        fontSize: 12,
    },
    PAYMENT_RECEIVED: {
        color: "grey",
        fontSize: 12,
    },
    POD_RECEIVED: {
        color: "#2680eb",
        fontSize: 12,
    },
    POD_SUBMITTED: {
        color: "#2680eb",
        fontSize: 12,
    },
    SETTLED: {
        color: "#00875a",
        fontSize: 12,
    },
    STARTED_BULLET: {
        color: "#2680eb",
        fontSize: 12,
    },
    COMPLETED_BULLET: {
        color: "#00875a",
        fontSize: 12,
    },
    PAYMENT_RECEIVED_BULLET: {
        color: "grey",
        fontSize: 12,
    },
    POD_RECEIVED_BULLET: {
        color: "#2680eb",
        fontSize: 12,
    },
    POD_SUBMITTED_BULLET: {
        color: "#2680eb",
        fontSize: 12,
    },
    SETTLED_BULLET: {
        color: "#00875a",
        fontSize: 12,
    },
    statusDiv: {
        display: 'flex', alignItems: 'center'
    },
    viewTripButton: {
        color: "#0033cc",
        borderColor: '#0033cc',
        textTransform: 'capitalize',
        fontSize: 12,
        letterSpacing: '1px',
        fontWeight: 300
    },
    divV1: {
        width: '100%',
        backgroundColor: '#d6def7',
        paddingTop: 16,
        paddingBottom: 16,
        paddingLeft: 24,
        paddingRight: 24,
        borderRadius: 8
    },
    divV2: {
        color: '#6b778c',
        fontSize: 18,
        fontWeight: 300,
    },
    divV3: {
        fontSize: 20,
        fontWeight: 500,
        marginTop: 8,
        fontWeight: 'bold',
    },
    divV4: {
        fontSize: 20,
        fontWeight: 500,
        marginTop: 8,
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    },
    editButton: {
        fontSize: 18,
        color: '#0033cc',
        backgroundColor: 'white',
        textTransform: 'capitalize',
        borderRadius: 4,
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    editIconColor: {
        color: '#0033cc',
        fontSize: '23px !important'
    },
    deleteButton: {
        fontSize: 18,
        color: 'red',
        backgroundColor: 'white',
        textTransform: 'capitalize',
        marginLeft: 16,
        borderRadius: 4,
        '&:hover': {
            backgroundColor: 'white'
        }
    },
    deleteIconColor: {
        color: 'red',
        fontSize: '23px !important'
    },
    circleOnTrip: {
        borderRadius: "50%",
        backgroundColor: "#2680eb",
        fontSize: 12,
        color: "#2680eb",
        marginLeft: 16,
        marginRight: 16
    },
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    dcV1: {
        fontSize: 17
    },
    spanV1: {
        fontWeight: 300,
        letterSpacing: "1px",
        fontSize: 18
    },
    taV1: {
        textAlign: 'center', cursor: 'pointer',
    },
    divV5: {
        width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginTop: 16
    },
    divV6: {
        display: 'flex'
    },
    divV7: {
        display: 'flex', marginTop: 16
    },
    divV8: {
        backgroundColor: '#ebebf1', marginTop: 16, paddingLeft: 78, paddingRight: 78, paddingBottom: 8, paddingTop: 8, borderRadius: 8
    },
    filterHeading: {
        color: '#9ea0a5', fontSize: 13, marginBottom: 4, fontWeight: 'bold'
    },
    mtV1: {
        marginLeft: 16
    },
    monthlyReportButton: {
        textTransform: 'capitalize', borderRadius: 4, color: 'white', backgroundColor: '#0033cc', fontWeight: 'bold',
        "&:hover": {
            backgroundColor: '#0033cc'
        }
    },
    profitV1: {
        display: 'flex', paddingTop: 16, paddingBottom: 16, paddingLeft: 16, paddingRight: 16, border: '1px solid  #eaedf3', alignItems: 'center'
    },
    profitV2: {
        display: 'flex', paddingTop: 16, paddingBottom: 16, paddingLeft: 16, paddingRight: 16, border: '1px solid  #eaedf3', alignItems: 'center', marginLeft: 24
    },
    profitHeading: {
        textTransform: 'uppercase', color: '#6b778c', fontWeight: 'bold'
    },
    profitValue1: {
        fontWeight: 'bold', fontSize: 22, marginLeft: 37
    },
    profitValue2: {
        color: '#6b778c', fontSize: 22, fontWeight: 'bold', marginLeft: 37
    },
    profitValue3: {
        color: '#00875a', fontSize: 22, fontWeight: 'bold', marginLeft: 37
    },
    profitValue4: {
        color: 'red', fontSize: 22, fontWeight: 'bold', marginLeft: 37
    },
    iconText: {
        color: '#161f34', fontWeight: 300, marginTop: 8
    },
    divTripIcon: {
        backgroundColor: 'white', padding: 10, borderRadius: 8,
        "&:hover": {
            padding: 8,
            border: '1px solid #0033cc'
        }
    },
    tripIcon: {
        //width: 46, height: 32
        fontSize: 40
    },
    divFuelIcon: {
        backgroundColor: 'white', borderRadius: 8, paddingTop: 10, paddingBottom: 10, paddingLeft: 12, paddingRight: 12,
        "&:hover": {
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 10,
            paddingRight: 10,
            border: '1px solid #0033cc'
        }
    },
    fuelIcon: {
        //width: 52, height: 60
        fontSize: 40
    },
    divEmiIcon: {
        backgroundColor: 'white', paddingTop: 14, paddingBottom: 10, paddingLeft: 10, paddingRight: 10, borderRadius: 8,
        "&:hover": {
            paddingTop: 12,
            paddingBottom: 12,
            paddingLeft: 8,
            paddingRight: 8,
            border: '1px solid #0033cc'
        }
    },
    emiIcon: {
        //width: 52, height: 52
        fontSize: 40
    },
    divDocumnetIcon: {
        backgroundColor: 'white', paddingTop: 10, paddingBottom: 10, paddingLeft: 16, paddingRight: 16, borderRadius: 8,
        "&:hover": {
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 14,
            paddingRight: 14,
            border: '1px solid #0033cc'
        }
    },
    documnetIcon: {
        //width: 52, height: 60
        fontSize: 40
    },
    divMaintenanceIcon: {
        backgroundColor: 'white', paddingTop: 10, paddingBottom: 10, paddingLeft: 18, paddingRight: 16, borderRadius: 8,
        "&:hover": {
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 16,
            paddingRight: 14,
            border: '1px solid #0033cc'
        }
    },
    maintenanceIcon: {
        //width: 46, height: 60
        fontSize: 40
    },
    divDriverIcon: {
        backgroundColor: 'white', paddingTop: 10, paddingBottom: 10, paddingLeft: 10, paddingRight: 10, borderRadius: 8,
        "&:hover": {
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 8,
            paddingRight: 8,
            border: '1px solid #0033cc'
        }
    },
    driverIcon: {
        //width: 60, height: 60
        fontSize: 40
    },
    divTripsAndExpenses: {
        backgroundColor: 'white', paddingTop: 10, paddingBottom: 10, paddingLeft: 12, paddingRight: 12, borderRadius: 8,
        "&:hover": {
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: 10,
            paddingRight: 10,
            border: '1px solid #0033cc'
        }
    },
    fuelBunkIcon: {
        fontSize: 62,
        '&:hover': {
            fontSize: 61,
            border: '1px solid #0033cc',
            borderRadius: '8px'
        }
    },
    tripsAndExpensesIcon: {
        //width: 60, height: 60
        fontSize: 40
    },
    revenue: {
        fontWeight: 300,
        color: '#0033cc'
    },
    fw300: {
        fontWeight: 'bold'
    },
    fromATrip: {
        fontWeight: 300, marginLeft: 16, borderRadius: '4px', color: 'white', backgroundColor: '#e86825', fontSize: 11, paddingTop: 2, paddingBottom: 2, paddingLeft: 8, paddingRight: 8
    },
    divV9: {
        display: 'flex', alignItems: 'center'
    },
    taCenter: {
        textAlign: 'center'
    },
    iconButtonV1: {
        borderRadius: '4px', border: '1px solid #0033cc', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px'
    },
    iconButtonV2: {
        borderRadius: '4px', border: '1px solid red', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px', marginLeft: '16px'
    },
    editIcon: {
        color: '#0033cc', fontSize: '16px'
    },
    deleteIcon: {
        color: 'red', fontSize: '16px'
    },
    vehicleTable: {
        marginTop: 16,
        '& .MuiTableRow-root': {
            cursor: 'default',
        }
    },
    vehicleTableV1: {
        marginTop: 16
    }
}));

//Trip Book Css
export const TripBookCss = makeStyles((theme) => ({
    viewPDFCta: {
        backgroundColor: '#0033cc',
        borderRadius: 4,
        border: 0,
        color: 'white',
        height: 36,
        padding: '7px 16px 7px 12px',
        margin: '0 16px',
        textTransform: 'capitalize',
        "&:hover": {
            backgroundColor: '#0033cc',
        }
    },
    seperator:{
        width:'100%',
        borderTop:'3px dotted rgba(0, 0, 0, 0.25)',
        margin:'16px 0'
    },
    divTripProfit: {
        textAlign: 'end'
    },
    divV1: {
        height: '100%',
    },
    divV2: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end'
    },
    emptyState: {
        fontSize: 20,
        fontWeight: 300,
        marginTop: '-10px'
    },
    divEmpty: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
    },
    marginV1: {
        marginTop: 16,
        paddingRight: 2
    },
    marginV2: {
        marginTop: 24
    },
    tripCardsLists: {
        marginTop: 24,
        height: "calc(100% - 158px);",
        overflow: "auto",
        paddingRight: 2
    },
    cardContentV1: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: '16px !important',
        display: 'flex',
        justifyContent: 'space-between'
    },
    titleV1: {
        color: '#6b778c',
        fontSize: 18,
        fontWeight: 500
    },
    totalRevenue: {
        fontWeight: 300,
        fontSize: 20
    },
    divProfit: {
        borderRadius: 8
    },
    profit: {
        color: '#00875a'
    },
    loss: {
        color: 'red'
    },
    svLogCard1: { borderRadius: '8px', marginBottom: '1em', marginTop: '8px' },
    tripBookCardContent: {
        paddingBottom: '10px !important',
        paddingTop: '24px'
    },
    tripLogCustomer: {
        fontSize: 20,
        display: 'flex',
        justifyContent: 'space-between',
        fontWeight: 300
    },
    profitHeader: {
        color: '#6b778c',
        fontSize: 18
    },
    profitAmount: {
        color: '#00875a',
        fontSize: 20
    },
    profitAmountLoss: {
        color: 'red',
        fontSize: 20
    },
    timeLineRoot: {
        paddingLeft: 0,
        height: '6em',
        marginBottom: '0px'
    },
    timeLineDot: {
        border: "1px solid #c7c7c7",
        backgroundColor: 'none',
    },
    timeLineDotRoot: {
        marginTop: '2px',
        marginBottom: '0px',
        borderWidth: '1px',
    },
    timeLineContent: {
        padding: "0px 8px",
        marginTop: -5,
    },
    timeLineContent1: {
        padding: "0px 8px",
        marginTop: -3,
    },
    timelineItem: {
        "&::before": {
            flex: 0,
            padding: 0,
        },
    },
    timeLineItemRoot: {
        minHeight: '40px'
    },
    timeLineItemRoot1: {
        minHeight: '31px'
    },
    timeLineConnector: {
        width: 1
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.2)",
        color: "#c7c7c7"
    },
    divView: {
        color: '#0033CC', fontSize: '18px', display: 'flex', alignItems: 'flex-end', paddingBottom: '10px', cursor: 'pointer'
    },
    divArrow: {
        fontSize: '17px', marginTop: '-5px'
    },
    divProfitHeader: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column'
    },
    dateRange: {
        color: '#9ea0a5',
        marginBottom: 4,
        fontSize: 13,
        fontWeight: 300
    },
    tripMonth: {
        color: '#6b778c',
        fontSize: 15,
        fontWeight: 300
    },
    fsV2: {
        fontSize: 20
    },
    mrV1: {
        marginRight: 5
    }
}));

export const FuelBookCss = makeStyles((theme) => ({
    doneIcon: {
        color: '#00875A'
    },
    dateRange: {
        color: '#9ea0a5',
        marginBottom: 4,
        fontSize: 13,
        fontWeight: 300
    },
    marginV1: {
        marginTop: 16,
    },
    cardV2: {
        borderRadius: 8, boxShadow: 'none !important'
    },
    cardV1: {
        marginBottom: '2px', borderRadius: 8, boxShadow: 'none !important'
    },
    cardContentV1: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: '16px !important',
        display: 'flex',
        justifyContent: 'space-between'
    },
    cardContentV2: {
        paddingBottom: '12px !important', paddingTop: '12px', paddingLeft: '16px', paddingRight: '6px'
    },
    titleV1: {
        color: '#6b778c',
        fontSize: 18,
        fontWeight: 500
    },
    totalRevenue: {
        fontWeight: 300,
        fontSize: 20
    },
    divProfit: {
        borderRadius: 8
    },
    marginV2: {
        marginTop: 24
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.3)",
        color: "#c7c7c7"
    },
    divEmptyState: {
        display: 'flex', flexDirection: 'column', alignItems: 'center', height: '90%', justifyContent: 'center'
    },
    fuelBookIcon: {
        width: '5em', height: '5em', marginLeft: '1em'
    },
    emptyState: {
        fontSize: '20px', fontWeight: 300, textAlign: 'center', marginTop: '-10px'
    },
    brV1: {
        borderRadius: 8
    },
    mbV1: {
        marginBottom: '6em'
    },
    divMonth: {
        color: '#6b778c', marginTop: '16px', fontSize: '14px', textTransform: 'uppercase', letterSpacing: "1px"
    },
    mtV1: {
        marginTop: '8px'
    },
    divHeading: {
        display: 'flex', fontWeight: '500', justifyContent: 'space-between', alignItems: 'center'
    },
    fzV1: {
        fontSize: 20
    },
    displayFlex: {
        display: 'flex'
    },
    pV1: {
        padding: 10
    },
    mlV1: {
        marginLeft: -8
    },
    editIcon: {
        fontSize: 19, color: '#0033cc'
    },
    deleteIcon: {
        color: 'red', fontSize: 19
    },
    divFromATrip: {
        width: '100%', display: 'flex', justifyContent: 'flex-end'
    },
    fromATrip: {
        marginRight: '10px', height: '16px', alignItems: 'center', display: 'flex', color: "#2c5de5", backgroundColor: "#d7e1fe", fontSize: '11px', paddingLeft: '4px', paddingRight: '4px', borderRadius: '5px', paddingTop: 2, paddingBottom: 1, letterSpacing: '0.03em', textTransform: 'uppercase', fontWeight: 300, marginTop: -3
    },
    divData: {
        display: 'flex', justifyContent: 'space-between', marginTop: 2
    },
    divV2: {
        marginTop: '-13px', display: 'flex', alignItems: 'center'
    },
    divAmount: {
        fontSize: 20, fontWeight: 'bold', paddingRight: 10
    }

}));


export const maintenanceBookCss = makeStyles((theme) => ({
    divV1: {
        color: 'red'
    },
    divEmptyState: {
        display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center'
    },
    emptyState: {
        fontSize: '20px', fontWeight: 300, textAlign: 'center', marginTop: '-10px'
    },
    maintenanceBookIcon: {
        width: '5em', height: '5em', marginLeft: '1em'
    },
    dateRange: {
        color: '#9ea0a5',
        marginBottom: 4,
        fontSize: 13,
        fontWeight: 300
    },
    marginV1: {
        marginTop: 16
    },
    brV1: {
        borderRadius: 8
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.3)",
        color: "#c7c7c7"
    },
    cardContentV1: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: '16px !important',
        display: 'flex',
        justifyContent: 'space-between'
    },
    titleV1: {
        color: '#6b778c',
        fontSize: 18,
        fontWeight: 500
    },
    totalRevenue: {
        fontWeight: 300,
        fontSize: 20
    },
    divFilter: {
        display: 'flex'
    },
    displayFlex: {
        display: 'flex'
    },
    pV1: {
        padding: 10
    },
    mlV1: {
        marginLeft: -8
    },
    editIcon: {
        fontSize: 19, color: '#0033cc'
    },
    deleteIcon: {
        color: 'red', fontSize: 19
    },
    divFromATrip: {
        width: '100%', display: 'flex', justifyContent: 'flex-end'
    },
    fromATrip: {
        marginRight: '10px', height: '16px', alignItems: 'center', display: 'flex', color: "#2c5de5", backgroundColor: "#d7e1fe", fontSize: '11px', paddingLeft: '4px', paddingRight: '4px', borderRadius: '5px', paddingTop: 2, paddingBottom: 1, letterSpacing: '0.03em', textTransform: 'uppercase', fontWeight: 300, marginTop: -3
    },
    divAmount: {
        fontSize: 20, fontWeight: 'bold', paddingRight: 10
    },
    mlV2: {
        marginLeft: 24
    },
    divV2: {
        marginTop: '2px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    marginV2: {
        marginTop: 24
    },
    divUpcomingHeader: {
        color: '#6b778c', fontWeight: 300, marginTop: '24px', fontSize: '15px'
    },
    cardContentV3: {
        paddingBottom: '12px !important', paddingTop: '12px', paddingRight: '20px', paddingLeft: '20px'
    },
    divV3: {
        display: 'flex', flexDirection: 'column', flexBasis: '60%'
    },
    divExpenseName: {
        fontWeight: 'bold', fontSize: 20
    },
    divV4: {
        display: 'flex', marginTop: '8px', alignItems: 'center'
    },
    divDue: {
        color: 'white', backgroundColor: '#de1c22', fontWeight: 'bold', paddingLeft: '7px', paddingRight: '7px', paddingBottom: '1px', paddingTop: '2px', borderRadius: '5px', fontSize: 12
    },
    divDate: {
        display: 'flex', color: '#656565', marginLeft: '6px'
    },
    divV5: {
        display: 'flex', flexBasis: '40%', justifyContent: 'flex-end', alignItems: 'center'
    },
    buttonV1: {
        borderRadius: '8px', textTransform: 'none', fontWeight: 300, height: '2.4em', paddingLeft: '8px', borderColor: '#f1f1f1', paddingRight: 12
    },
    doneIconV1: {
        color: '#008556', width: '0.78em'
    },
    divMarkDone: {
        color: '#008556', marginLeft: '8px', letterSpacing: '0.04em'
    },
    mbV1: {
        marginBottom: '6em'
    },
    divMonth: {
        color: '#6b778c', marginTop: '16px', textTransform: 'uppercase', fontSize: '15px', letterSpacing: '1px'
    },
    mtV2: {
        marginTop: '8px'
    },
    cardContentV4: {
        paddingBottom: '12px !important', paddingTop: '12px', paddingLeft: '20px', paddingRight: '20px'
    },
    divV6: {
        display: 'flex', fontWeight: 'bold', justifyContent: 'space-between', alignItems: 'center'
    },
    fsV1: {
        fontSize: 20
    }
}));

export const driverBookCss = makeStyles((theme) => ({
    divEmptyState: {
        display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center'
    },
    emptyState: {
        fontSize: '20px', fontWeight: 300, textAlign: 'center', marginTop: '-10px'
    },
    driverBookIcon: {
        width: '5em', height: '5em', marginLeft: '1em'
    },
    divFilter: {
        display: 'flex'
    },
    dateRange: {
        color: '#9ea0a5',
        marginBottom: 4,
        fontSize: 13,
        fontWeight: 300
    },
    mlV2: {
        marginLeft: 24
    },
    marginV1: {
        marginTop: 16
    },
    brV1: {
        borderRadius: 8
    },
    cardContentV1: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: '16px !important',
        display: 'flex',
        justifyContent: 'space-between'
    },
    titleV1: {
        color: '#6b778c',
        fontSize: 18,
        fontWeight: 500
    },
    totalRevenue: {
        fontWeight: 300,
        fontSize: 20
    },
    mbV1: {
        marginBottom: '6em'
    },
    divMonth: {
        color: '#6b778c', marginTop: '16px', textTransform: 'uppercase', fontSize: '15px', letterSpacing: '1px'
    },
    mtV2: {
        marginTop: '8px'
    },
    cardContentV4: {
        paddingBottom: '12px !important', paddingTop: '12px', paddingLeft: '20px', paddingRight: '20px'
    },
    divV6: {
        display: 'flex', fontWeight: 'bold', justifyContent: 'space-between', alignItems: 'center'
    },
    fsV1: {
        fontSize: 20
    },
    displayFlex: {
        display: 'flex'
    },
    pV1: {
        padding: 10
    },
    editIcon: {
        fontSize: 19, color: '#0033cc'
    },
    deleteIcon: {
        color: 'red', fontSize: 19
    },
    mlV1: {
        marginLeft: -8
    },
    divFromATrip: {
        width: '100%', display: 'flex', justifyContent: 'flex-end'
    },
    fromATrip: {
        marginRight: '10px', height: '16px', alignItems: 'center', display: 'flex', color: "#2c5de5", backgroundColor: "#d7e1fe", fontSize: '11px', paddingLeft: '4px', paddingRight: '4px', borderRadius: '5px', paddingTop: 2, paddingBottom: 1, letterSpacing: '0.03em', textTransform: 'uppercase', fontWeight: 300, marginTop: -3
    },
    divV2: {
        marginTop: '2px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    divAmount: {
        fontSize: 20, fontWeight: 'bold', paddingRight: 10
    },
}));



export const documentBookCss = makeStyles((theme) => ({
    divAlertEmpty: {
        backgroundColor: '#c2d3f3', paddingBottom: 7, paddingTop: 7, borderRadius: 6, display: 'flex', alignItems: 'center', paddingLeft: 11
    },
    divAlert: {
        backgroundColor: '#f9d3d4', paddingBottom: 7, paddingTop: 7, borderRadius: 6, display: 'flex', alignItems: 'center', paddingLeft: 11
    },
    errorIconEmpty: {
        color: 'darkblue', fontSize: 17
    },
    errorIcon: {
        color: 'red', fontSize: 17
    },
    alertText: {
        fontSize: 12, marginLeft: 10, fontWeight: 300
    },
    mtV1: {
        marginTop: 30
    },
    cardV1: {
        marginBottom: 8,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#F8F8F8',
        },
    },
    cardContentV1: {
        padding: '16px !important', display: 'flex', alignItems: 'center'
    },
    divThumbNail: {
        cursor: 'pointer',
    },
    divIcon: {
        borderRadius: 8, backgroundColor: '#F5F5F5', padding: 18
    },
    colorV1: {
        color: '#0033cc'
    },
    mlV1: {
        marginLeft: 12
    },
    fw300: {
        fontWeight: 300
    },
    divAddExpiry: {
        color: '#0033cc', fontSize: 12, marginTop: 4
    },
    divDocumentId: {
        fontWeight: 'bold',
        fontSize: 12,
        marginTop: 3,
        color: '#A0A0A0',
    },
    alertDanger: {
        paddingTop: 1,
        paddingBottom: 3,
        paddingLeft: 5,
        paddingRight: 5,
        backgroundColor: "#f9d3d4",
        color: "#de1c22",
        fontSize: 10,
        borderRadius: 5,
        marginTop: 4
    },
    alertDanger1: {
        paddingTop: 1,
        paddingBottom: 3,
        paddingLeft: 5,
        paddingRight: 5,
        backgroundColor: "#ffe1be",
        color: "#de1c22",
        fontSize: 10,
        borderRadius: 5,
        marginTop: 4
    },
    alertDanger2: {
        paddingTop: 1,
        paddingBottom: 3,
        paddingLeft: 5,
        paddingRight: 5,
        backgroundColor: "#f1f1f1",
        fontSize: 10,
        borderRadius: 5,
        marginTop: 4
    },
    imgV1: {
        width: 53, height: 53, borderRadius: 8
    },
    editMenuIcon: { fontSize: 16, borderBottom: '2px solid black' },
    deleteMenuIcon: { fontSize: 16 },
    deleteMenu: { color: 'red', fontWeight: 300 },
    cardContentV2: {
        padding: '16px !important', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'
    },
    dFlex: {
        display: 'flex',
        width: '80%',
    },
    widthV1: {
        width: '15%',
    },
    singleVehicleMenu: {
        position: "absolute",
        zIndex: 10000,
        //top:"7%",
        display: "flex",
        marginLeft: -90,
        justifyContent: "flex-end",
        //width: "100%",
        [theme.breakpoints.up("lg")]: {
            maxWidth: 478,
        },
        [theme.breakpoints.up("xl")]: {
            maxWidth: 478,
        }
    },
    singleVehicleMenuPaper: {
        minWidth: 140
    },
    moreIcon: {
        fontSize: 17,
        color: '#0033cc'
    },
    mtV3: {
        marginTop: -10,
    },
    pdfIcon: {
        fontSize: 18, color: '#0033cc'
    },
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    renewForward: {
        fontSize: 12,
        color: '#0033cc'
    },
    renewAction: {
        fontSize: 12,
        color: '#0033cc',
    },
    divRenew: {
        marginTop: 8,
        paddingLeft: 6,
        cursor: 'pointer',
        "&:hover": {
            backgroundColor: '#F0F0F0'
        }
    },
    paperWidth: {
        maxWidth: 512
    },
    paper1: {
        borderRadius: 4,
    },
    dialogTitleV1: {
        paddingLeft: 30, paddingTop: 10, paddingBottom: '10px !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& .MuiTypography-root': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    marginV3: {
        marginTop: 28
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    S3UploaderImageMargin: {
        margin: '0 0 0 8px',
    },
    S3UploaderImageDiv: {
        margin: '4px 4px 4px 8px',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer'
    },
    S3UploaderImageSrc: {
        width: '46px',
        height: '46px',
        objectFit: 'cover',
        borderRadius: '8px',
        border: "2px solid black"
    },
    S3UploaderImageSrcActive: {
        width: '46px',
        height: '46px',
        objectFit: 'cover',
        borderRadius: '8px',
        border: "3px solid #0033cc"
    },
    paperWidthV1: {
        width: '22%'
    },
    shareIcon: {
        marginLeft: '-5px', width: '1.3em', height: '1.3em'
    },
    divDelete: {
        fontWeight: 'bold', fontSize: '16px'
    },
    mtV4: {
        marginTop: '8px'
    },
    mtV5: {
        marginTop: '20px'
    },
    mlV3: {
        marginLeft: '-8px'
    },
    divV10: {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '12px'
    },
    fzV1: {
        fontSize: '16px'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    deleteIconV1: {
        color: 'red', fontSize: '22px'
    },
    taEnd: {
        textAlign: 'end'
    },
    mWV1: {
        maxWidth: '100%'
    },
    divNo: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    divYes: {
        color: '#0033cc', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    paperItem: {
        marginTop: '20px', textAlign: 'center', backgroundColor: '#f1f1f1', paddingTop: '6em', paddingBottom: '6em', borderRadius: '8px'
    },
    imgV2: {
        height: "20em"
    },
    mlV4: {
        marginLeft: '-8px'
    },
    divImageEmpty: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '12em',
        marginBottom: '11em',
    },
    documnetEmptyIcon: {
        fontSize: '7em',
    },
    divEmptyText: {
        fontSize: 20, color: 'grey', fontWeight: 300, marginTop: 12, textAlign: 'center'
    },
}));

export const emiBookCss = makeStyles((theme) => ({
    divEmptyState: {
        display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'center'
    },
    emptyState: {
        fontSize: '20px', fontWeight: 300, textAlign: 'center', marginTop: '-10px'
    },
    emiBookIcon: {
        width: '4em', height: '5em', marginLeft: '1em'
    },
    status1: {
        color: 'white',
        backgroundColor: '#de1c22',
        fontWeight: 'bold',
        paddingLeft: '7px',
        paddingRight: '7px',
        paddingBottom: '2px',
        paddingTop: '3px',
        borderRadius: '5px',
        fontSize: 12
    },
    status2: {
        color: 'white',
        backgroundColor: '#008556',
        fontWeight: 'bold',
        paddingLeft: '7px',
        paddingRight: '7px',
        paddingBottom: '2px',
        paddingTop: '3px',
        borderRadius: '5px',
        fontSize: 12
    },
    singleVehicleMenu: {
        position: "absolute",
        zIndex: 10000,
        top: "13%",
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        marginRight: '-12px',
        [theme.breakpoints.up("lg")]: {
            maxWidth: 478,
        },
        [theme.breakpoints.up("xl")]: {
            maxWidth: 478,
        }
    },
    singleVehicleMenuPaper: {
        width: 170
    },
    displayFlex: {
        display: 'flex'
    },
    pV1: {
        padding: 10
    },
    mlV1: {
        marginLeft: -8
    },
    editIcon: {
        fontSize: 19, color: '#0033cc'
    },
    deleteIcon: {
        color: 'red', fontSize: 19
    },
    divDelete: {
        fontWeight: 'bold', fontSize: '16px'
    },
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    mtV4: {
        marginTop: '8px'
    },
    deleteMenuIcon: { fontSize: 16 },
    deleteMenu: { color: 'red', fontWeight: 300 },
    divMark: {
        fontSize: 20,
        fontWeight: 'bold'
    },
    divMarkBody: {
        marginTop: 16,
        fontSize: 16,
    },
    fwBold: {
        fontWeight: 'bold'
    },
    paper2: {
        borderRadius: '6px',
    },
    cardV1: {
        marginTop: '8px', borderRadius: 8
    },
    cardContentV1: {
        textAlign: 'center', paddingBottom: '16px !important', paddingTop: '4px !important'
    },
    divV1: {
        display: 'flex', justifyContent: 'flex-end'
    },
    colorV1: {
        color: "#8b8b8e"
    },
    doneIcon: {
        color: '#008556', fontSize: '20px', marginTop: '3px'
    },
    mtV1: {
        marginTop: '-35px'
    },
    divV2: {
        fontWeight: 300, fontSize: 16
    },
    divV3: {
        fontSize: '28px', fontWeight: 'bold', letterSpacing: '1px'
    },
    divV4: {
        display: 'flex', justifyContent: 'center', marginTop: '4px'
    },
    divV5: {
        display: 'flex', color: '#656565', marginLeft: '8px'
    },
    divV6: {
        color: '#6b778c', fontWeight: 300, marginTop: '16px', fontSize: '14px'
    },
    mtV2: {
        marginTop: '8px'
    },
    cardContentV2: {
        paddingBottom: '12px !important', paddingTop: '12px !important', paddingRight: '20px !important', paddingLeft: '20px !important'
    },
    divV7: {
        display: 'flex'
    },
    divV8: {
        display: 'flex', flexDirection: 'column', flexBasis: '60%'
    },
    divV9: {
        fontWeight: 'bold', fontSize: 20
    },
    divV10: {
        display: 'flex', marginTop: '6px', alignItems: 'center'
    },
    divDue: {
        color: 'white', backgroundColor: '#de1c22', fontWeight: 'bold', paddingLeft: '7px', paddingRight: '7px', paddingBottom: '2px', paddingTop: '3px', borderRadius: '5px', fontSize: 12
    },
    divV11: {
        display: 'flex', color: '#656565', marginLeft: '12px'
    },
    divV12: {
        display: 'flex', flexBasis: '40%', justifyContent: 'flex-end', alignItems: 'center'
    },
    buttonV1: {
        borderRadius: '8px', textTransform: 'none', fontWeight: 300, paddingLeft: '6px', paddingTop: '5px', paddingBottom: '5px', paddingRight: 11
    },
    doneV2: {
        color: '#008556', width: '0.78em'
    },
    spanV1: {
        color: '#008556', marginLeft: '8px', letterSpacing: '0.04em'
    },
    mtV3: {
        marginTop: '8px'
    },
    divV13: {
        color: '#6b778c', fontWeight: 300, marginTop: '16px', fontSize: '14px'
    },
    cardContentV3: {
        paddingBottom: '12px !important', paddingTop: '12px !important', paddingLeft: '20px !important', paddingRight: '20px !important'
    },
    divV14: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    divV15: {
        fontWeight: 300, fontSize: 20
    },
    divV16: {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
    },
    colorV2: {
        color: '#656565'
    },
    divV17: {
        fontWeight: 'bold', fontSize: 20, paddingLeft: 10
    },
    spanCancel: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    spanConfirm: {
        color: '#0033cc', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    }
}));

export const vehicleMonthlyReportCss = makeStyles((theme) => ({
    divAlign: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    divMonth: {
        color: '#6b778c', fontWeight: 'bold', letterSpacing: '1px'
    },
    divPdf: {
        display: 'flex', alignItems: 'center', color: '#0033cc', fontWeight: 300, letterSpacing: '0.04em', cursor: 'pointer', paddingLeft: 6, paddingRight: 4, paddingTop: 4, paddingBottom: 4,
        '&:hover': {
            backgroundColor: '#E0E0E0'
        }
    },
    divAlignV1: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'
    },
    divAlignV2: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10
    },
    divAlignV3: {
        display: 'flex', alignItems: 'center'
    },
    divValue: {
        fontSize: 18,
        fontWeight: 300,
        marginTop: 6
    },
    divValueV1: {
        fontWeight: 300,
        color: '#0033cc'
    },
    divTitle: {
        color: '#6b778c', fontWeight: 300
    },
    divItems: {
        width: '100%',
        backgroundColor: '#F5F5F5',
        paddingTop: 8,
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 6
    },
    fw300: {
        fontWeight: 300
    },
    mtV1: {
        marginTop: 16
    },
    cardContentV1: {
        padding: '24px !important'
    },
    cardV1: {
        borderRadius: '6px !important',
        marginTop: 12
    },
    hrV1: {
        borderTop: '1px dashed lightgrey'
    },
    colorV2: {
        color: 'lightgrey'
    },
    mrV1: {
        marginRight: 8
    },
    colorV1: {
        color: '#6b778c'
    },
    boxShadow: {
        boxShadow: 'none !important',
        padding: '0px !important'
    },
    arrowDownV1: {
        color: '#6b778c',
        marginTop: '-1px',
    },
    arrowUpV1: {
        color: '#6b778c',
        marginTop: '-1px',
    },
    divCenter: {
        display: 'flex',
        alignItems: 'center',
        padding: '0px !important',
        margin: '0px !important'
    },
    rootV1: {
        padding: '0px !important',
        minHeight: '0px !important',
        '&:hover': {
            backgroundColor: '#F8F8F8',
            cursor: 'pointer'
        }
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.3)",
        color: "#c7c7c7"
    },
    dFlex: {
        display: 'flex'
    },
    pdV1: {
        padding: '0px !important'
    },
    divProfit: {
        fontSize: 18,
        fontWeight: 300
    },
    profit: {
        fontSize: 18,
        color: '#00875a'
    },
    loss: {
        fontSize: 18,
        color: 'red'
    },
    mlV5: {
        marginLeft: 5
    }
}));
